export default __webpack_public_path__ + "static/media/editt.2f0e38b2.png";